import { Clock, CalendarDays } from "lucide-react";
import { useLang } from "../../lib/lang";
import { useOpenStatus, useWeek } from "../../lib/hours";

export const OpenBadge = ({ light = false }) => {
  const { open, label } = useOpenStatus();
  return (
    <span
      data-testid="open-status-badge"
      title={label}
      className={`inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-medium whitespace-nowrap ${light ? "bg-white/10 text-white ring-1 ring-white/25 backdrop-blur-md" : "bg-[#721121]/[0.06] text-[#1C1917] ring-1 ring-[#721121]/20"}`}
    >
      <span className="relative flex h-2 w-2">
        {open && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />}
        <span className={`relative inline-flex h-2 w-2 rounded-full ${open ? "bg-emerald-500" : "bg-[#E05252]"}`} />
      </span>
      <span>{label}</span>
    </span>
  );
};

export const WeeklyHours = ({ light = false }) => {
  const { lang } = useLang();
  const { rows, upcoming } = useWeek();
  const sv = lang === "sv";
  const accent = light ? "text-[#E9C46A]" : "text-[#721121]";
  return (
    <div data-testid="weekly-hours">
      <p className={`flex items-center gap-2 text-xs uppercase tracking-[0.25em] ${accent}`}>
        <Clock size={14} /> {sv ? "Öppettider" : "Opening hours"}
      </p>
      <ul className="mt-4 space-y-1.5">
        {rows.map((r, i) => (
          <li key={r.name} data-testid={`hours-row-${i}`} className={`flex justify-between gap-8 text-sm ${r.isToday ? (light ? "font-semibold text-white" : "font-semibold text-[#721121]") : light ? "text-white/80" : "text-[#57534E]"}`}>
            <span>{r.name}{r.special && <span className={`ml-1 ${accent}`}>*</span>}</span>
            <span className="tabular-nums">{r.text}</span>
          </li>
        ))}
      </ul>
      {upcoming.length > 0 && (
        <div data-testid="upcoming-special-hours" className={`mt-5 border-t pt-4 ${light ? "border-white/15" : "border-[#721121]/15"}`}>
          <p className={`flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] ${accent}`}>
            <CalendarDays size={13} /> {sv ? "Kommande avvikande öppettider" : "Upcoming special hours"}
          </p>
          <ul className="mt-2 space-y-1">
            {upcoming.map((s) => (
              <li key={s.id} data-testid={`upcoming-special-${s.date}`} className={`flex justify-between gap-6 text-sm ${light ? "text-white/90" : "text-[#1C1917]"}`}>
                <span>* {s.label}{s.note ? ` · ${s.note}` : ""}</span>
                <span className="tabular-nums">{s.text}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
